export const compassEmail = ['service', ['compassbioinfo', 'com'].join('.')].join('@')

export const externalLinkDatas = () => {
  const lang = {
    'ja': 'ja'
  }[localStorage.getItem('locale') || window.navigator.language || navigator.userLanguage] || 'en'
  return {
    'expert': 'https://expert.inherinext.com/',
    'inherinext': {
      'ja': 'https://edge.inherinext.jp/',
      'en': 'https://edge.inherinext.jp/'
    }[lang]
  }
}



// WEBPACK FOOTER //
// ./src/constants/global/data.js